/**
 * Returns a Capitalized copy of the passed in string.
 * @param {String} text Title text string to capitalize
 */
const capitalize = text =>
  text && text.length > 0 ? `${text[0].toUpperCase()}${text.slice(1)}` : ''

/**
 * Returns a cleaned copy of the passed in string or an empty string if the passed in string is `null` or `undefined`
 * Replaces HTML encoded entities with their decoded equivalents.
 * @param {String} text Title text string to copy, mutate and clean
 */
const cleanTitle = text =>
  text && text.length ? text.replace(/&#038;/g, '&') : ''

/**
 * Returns a cleaned copy of the passed in string or an empty string if the passed in string is `null` or `undefined`
 * Removes forward slashes '/' from the passed in string.
 * @param {String} text Title text string to copy, mutate and clean
 */
const stripSlashes = text =>
  text && text.length ? text.replace(/\//g, '') : ''

/**
 * Returns a boolean indicating whether `true` or not `false` the string is an email address
 * @param {String} text The text string to check
 */
const isEmail = text =>
  text.length > 0 && text.indexOf('@') > 0 && text.indexOf('.') >= 1

/**
 * Converts a JSON object to a `?key1=value1&key2=value2` query string
 * @param {Object} queryObj JSON object to convert to key value pairs
 * @param {String} prefix Optional prefix to prepend to the query string. Defaults to `?`
 */
const queryStringFromObj = (queryObj, prefix = '?') => {
  let queryString = prefix

  // Build our requestURL
  for (const prop in queryObj) queryString += `${prop}=${queryObj[prop]}&`

  // Remove the trailing ampersand
  queryString = queryString.slice(0, -1)

  return queryString
}

const parseMilissecondsToMinutes = time => {
  if (time === 0) return '0:00'
  if (!time) return

  const minutes = Math.floor(time / 60)
  const seconds = Math.floor(time - minutes * 60)

  const sencodsString = seconds < 10 ? `0${seconds}` : seconds

  return `${minutes}:${sencodsString}`
}

export {
  capitalize,
  cleanTitle,
  stripSlashes,
  isEmail,
  queryStringFromObj,
  parseMilissecondsToMinutes
}
